import { TAG_NAME_NEW } from "@shared/constants/game";
import { toArray } from "lodash-es";
import { useMemo } from "react";
import { useSelector } from "react-redux";

export const useTags = () => {
  return useSelector(({ games }) => games.tags);
};

export const useCurrentTagId = () => {
  return useSelector(({ games }) => games.currentTagId);
};

export const useCurrentTag = () => {
  const tags = useTags();
  const currentTagId = useCurrentTagId();

  return useMemo(() => {
    const currentTag = tags.find((tag) => tag.id === currentTagId);
    return currentTag ?? null;
  }, [tags, currentTagId]);
};

export const useComputedTags = () => {
  return useSelector(({ games }) => {
    const computedTags = [...toArray(games.computedTags)];
    const newTag = computedTags?.find((tag) => tag.name === TAG_NAME_NEW);

    if (newTag?.name) {
      computedTags.unshift(newTag);
    }

    return [...new Set(computedTags)];
  });
};
